import React, { useState } from 'react';
import { IconButton } from './ui/button';
import { useManagerEntity } from '@/shared/managerHelpers';
import { PiMetronomeThin } from 'react-icons/pi';
import { PiMinus } from 'react-icons/pi';
import { PiPlus } from 'react-icons/pi';
import { PiPower } from 'react-icons/pi';
import { Input } from './ui/input';
import { cn } from '@/lib/utils';

const MetronomeSettings = () => {
  const ManagerEntity = useManagerEntity();

  const metronome = ManagerEntity?.metronome;

  const [isPlaying, setIsPlaying] = useState(false);

  const [bpm, setBpm] = useState<number>(metronome?.bpm ?? 80);

  function handleInputChange(event: any) {
    const bpm = event.target.value;
    metronome.bpm = bpm;
    setBpm(bpm);
    if (isPlaying) {
      metronome.playOn();
    }
  }

  const setNewBmp = (value: number) => {
    metronome.bpm = value;
    setBpm(value);
    if (isPlaying) {
      metronome.playOn();
    }
  };

  if (!ManagerEntity) {
    return null;
  }

  return (
    <div className='flex items-center gap-1' id='metronome'>
      <div className='p-1'>
        <PiMetronomeThin size={36} />
      </div>

      <div className='hidden lg:flex py-1 px-3 border rounded-md w-full items-center justify-center gap-1'>
        <IconButton
          onClick={() => {
            if (bpm > 10) {
              setNewBmp(Number(bpm) - 10);
            }
          }}
          noHover
          noPadding
        >
          <PiMinus size={16} />
        </IconButton>
        <div className='flex mx-1 items-center justify-center group relative'>
          <Input
            value={bpm}
            id='bpm'
            placeholder='BPM'
            defaultValue={bpm}
            onBlur={() => {
              if (!bpm) {
                setBpm(80);
              }
            }}
            onChange={handleInputChange}
            className={`border-0 peer p-0 text-base md:text-base font-medium transition-all focus:translate-x-[25%] focus:max-w-[3ch] focus-visible:ring-0`}
            style={{
              maxWidth: bpm.toString().split('').length + 4 + 'ch',
            }}
          />
          <label
            htmlFor='bpm'
            className='absolute cursor-pointer flex items-center peer-focus:opacity-0 transition-all right-0 top-0 bottom-0'
          >
            <div className='font-medium text-base'>BPM</div>
          </label>
        </div>
        <IconButton
          onClick={() => {
            setNewBmp(Number(bpm) + 10);
          }}
          noHover
          noPadding
        >
          <PiPlus size={16} />
        </IconButton>
        <div className='w-[1px] h-5 bg-zinc-200 mx-2' />
        <IconButton
          onClick={() => {
            metronome.isActive = !isPlaying;
            if (!isPlaying) {
              metronome.playOn();
            } else {
              metronome.playOff();
            }
            setIsPlaying(!isPlaying);
          }}
          noHover
          noPadding
          className='hover:text-accent-blue'
        >
          <PiPower
            size={20}
            className={isPlaying ? 'fill-accent-blue' : 'fill-dark'}
          />
        </IconButton>
      </div>
    </div>
  );
};

export default MetronomeSettings;
